import axios from "axios";
import { getCookie } from "../../../App";
import { domain } from "../../Links/Links";

export async function TransactionRequest(link, setData, setLoadingStatus) {
  const response = await axios.get(
    domain + "/transaction/?link=" + link,
    {
      withCredentials: true,
    },
  );

  if (response.data) {
    setData(response.data);
    setLoadingStatus(true);

    if (response.data.token == "TRX" && response.data.status == "Waiting") {
      await TRXSendRequet(link);
    }
  }
}

export async function TRXSendRequet(link) {
  try {
    const data = {
      link: link,
    };
    const response = await axios.post(
      window.main_domain + "trx_send_in_transaction/",
      data,
      {
        withCredentials: true,
        headers: { "X-CSRFToken": getCookie("csrf_token") },
      },
    );

    if (response.data) {
      console.log(response.data);
    }
  } catch (e) {
    console.log(e);
  }
}
